import { render } from "./baobei.vue?vue&type=template&id=cba3dd7c&scoped=true"
import script from "./baobei.vue?vue&type=script&lang=js"
export * from "./baobei.vue?vue&type=script&lang=js"

import "./baobei.vue?vue&type=style&index=0&id=cba3dd7c&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba3dd7c"]])

export default __exports__